<div class="request-card-selection mb-3">
  <label *ngIf="label" class="form-label mb-2 d-block" [class.fw-semibold]="labelBold">
    {{ label }}
    <span *ngIf="required">*</span>
  </label>

  <div class="row g-2 justify-content-center">
    <div [ngClass]="cssClass" *ngFor="let option of options">
      <div class="card p-1 h-100" 
        [class.border-primary]="isSelected(option.value)"
        [class.border-danger]="showError"
        [class.bg-light]="isSelected(option.value)" 
        (click)="selectOption(option.value)" 
        role="button" 
        tabindex="0"
        (keydown.enter)="selectOption(option.value)" 
        (keydown.space)="selectOption(option.value)">

        <div class="card-body d-flex align-items-center p-2" 
          [ngClass]="{'row':option.icon && option.centerIcon}"
          [class.justify-content-center]="!option.icon || option.centerIcon"
          [class.justify-content-start]="option.icon && !option.centerIcon"
          [ngStyle]="{ 'min-height': option.minHeight || 'auto' }">
          <div [ngClass]="{'col-1 col-sm-2 d-flex justify-content-end pe-0':option.icon && option.centerIcon}">
            <i *ngIf="option.icon" [class.me-2]="!option.centerIcon" class=" ti" [ngClass]="option.icon"
              [style.fontSize]="option.centerIcon ? '22px' : '25px'" style="flex-shrink: 0"></i>
          </div>

          <div class="d-flex flex-column"
            [ngClass]="{'col-4 col-sm-4 col-md-6 col-lg-6 d-flex justify-content-start text-start':option.icon && option.centerIcon, 'text-center':!option.icon}">
            <h6 class="card-title m-0 small-label" [class.text-primary]="isSelected(option.value)"
              [class.fw-semibold]="isSelected(option.value)">
              {{ option.label }}
            </h6>

            <p *ngIf="option.description" class="description-text mb-0 mt-1 text-muted">
              {{ option.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="invalid-feedback d-block" *ngIf="showError">
    {{ errorMessage }}
  </div>
</div>